import React from 'react';
import { getVPInformation, getVPTypeIconPath } from './UIGameVPInformation.ts';
import styles from './UIGameHelpVPInformation.module.scss';
import { T, Tooltip } from '@colonist/ui';
import { VictoryPointType } from '@colonist/game-states';
import clsx from 'clsx';
import IconTrophy from '@static/images/icon_trophy.svg';
export const UIGameHelpVPInformation = ({ gameMode, isMechanicIslandExplorationActive, playerColor, victoryPointsToWin })=>{
    const gameModeData = getVPInformation(gameMode, isMechanicIslandExplorationActive);
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.uiGameInfoContainer
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.description
    }, /*#__PURE__*/ React.createElement("span", null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.beginnerTips.reach'
        }
    }), " "), /*#__PURE__*/ React.createElement("span", {
        className: styles.point
    }, victoryPointsToWin, " "), /*#__PURE__*/ React.createElement("img", {
        className: styles.trophyIcon,
        src: IconTrophy
    }), /*#__PURE__*/ React.createElement("span", null, " ", /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.beginnerTips.toWinTheGame'
        }
    }))), gameModeData.map((item, index)=>/*#__PURE__*/ React.createElement("div", {
            className: styles.itemRow,
            key: index
        }, /*#__PURE__*/ React.createElement(Tooltip, {
            centerText: true,
            className: styles.itemTitle,
            content: item.description && /*#__PURE__*/ React.createElement(T, {
                id: item.description
            }),
            delay: 0
        }, /*#__PURE__*/ React.createElement("img", {
            className: styles.icon,
            src: getVPTypeIconPath(item, playerColor)
        }), item.secondaryIcon != null && /*#__PURE__*/ React.createElement("img", {
            className: clsx(styles.secondaryIcon, {
                [styles.metropolis]: item.type === VictoryPointType.Metropolis,
                [styles.chits]: item.type === VictoryPointType.Chits
            }),
            src: item.secondaryIcon
        }), /*#__PURE__*/ React.createElement("div", {
            className: styles.title
        }, /*#__PURE__*/ React.createElement(T, {
            id: item.title
        }))), /*#__PURE__*/ React.createElement("div", {
            className: styles.pointContainer
        }, /*#__PURE__*/ React.createElement("div", {
            className: styles.point
        }, "+", item.vpAmount), /*#__PURE__*/ React.createElement("img", {
            className: styles.trophyIcon,
            src: IconTrophy
        })))));
};
